var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSIgnOutIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.997,
    height: 18,
    viewBox: "0 0 19.997 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23474",
    "data-name": "Path 23474",
    d: "M4,18a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H8a4,4,0,0,1,4,4V5.75a1,1,0,0,1-1,1H5a2.251,2.251,0,0,0,0,4.5h6a1,1,0,0,1,1,1V14a4,4,0,0,1-4,4Zm10.293-4.292a.994.994,0,0,1,0-1.413L16.585,10H5A1,1,0,0,1,5,8H16.588L14.3,5.712A1,1,0,1,1,15.707,4.3l3.977,3.974a1.085,1.085,0,0,1,.165.2.114.114,0,0,0,.012.016V8.5l.006.01a.04.04,0,0,1,.008.015A.986.986,0,0,1,20,9a1,1,0,0,1-.122.476.065.065,0,0,1-.008.015l-.006.01v.01a.112.112,0,0,0-.012.016,1.029,1.029,0,0,1-.165.2L15.707,13.7a1,1,0,0,1-1.412.007Z",
    transform: "translate(0 -0.001)",
    fill: "#33374a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSIgnOutIconHover);
export default __webpack_public_path__ + "static/media/SIgnOutIconHover.9d72520c519afdbb1ed0905dfcd1505e.svg";
export { ForwardRef as ReactComponent };